import {
  AfterViewInit,
  Component,
  forwardRef,
  Host,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Renderer2,
  SkipSelf
} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import {ISignaturePadConfig} from '../../interfaces/signature-pad-config.interface';
import {GlobalSignaturePadConfig} from '../../tokens/global-config.token';
import {SignaturePadComponent} from '../signature-pad/signature-pad.component';
export class SignaturePadControlComponent extends SignaturePadComponent implements OnChanges, OnInit, AfterViewInit, ControlValueAccessor {

  
  formControlName: string;

  control: FormControl;

  onTouch = () => {
  }

  onModelChange = (value: any) => {
  }
/**
 * @param {?} renderer
 * @param {?} parentFormContainer
 * @param {?=} defaultConfig
 */
constructor(renderer: Renderer2,
private parentFormContainer: ControlContainer,
                defaultConfig?: ISignaturePadConfig) {
    super(renderer, defaultConfig);
  }
/**
 * @return {?}
 */
ngOnInit() {
    super.ngOnInit();
    if (this.parentFormContainer) {
      this.control = this.parentFormContainer['form'].controls[this.formControlName];
    }
  }
/**
 * @param {?} signatureData
 * @return {?}
 */
writeValue(signatureData: any): void {
   this.renderViewValue(signatureData);
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
/**
 *
 * @param {?} isFocus
 * @return {?}
 */
handleFocus(isFocus: boolean): void {
    super.handleFocus(isFocus);
    if (!isFocus) {
      this.onTouch();
    }
  }
/**
 *
 * @param {?} signatureData
 * @return {?}
 */
handleInput(signatureData: any) {
    super.handleInput(signatureData);
    this.onModelChange(signatureData);
  }
/**
 * @return {?}
 */
clear() {
    super.clear();
    this.onModelChange([]);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'signature-pad-control',
  template: `
    <canvas
      tabindex="0"
      class="signature-pad-canvas"
      width="400"
      height="200"
      #signatureCanvas>
    </canvas>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SignaturePadControlComponent),
      multi: true
    }
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ControlContainer, decorators: [{ type: Optional }, { type: Host }, { type: SkipSelf }, ]},
{type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [GlobalSignaturePadConfig, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'formControlName': [{ type: Input },],
};
}

function SignaturePadControlComponent_tsickle_Closure_declarations() {
/** @type {?} */
SignaturePadControlComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SignaturePadControlComponent.ctorParameters;
/** @type {?} */
SignaturePadControlComponent.propDecorators;
/** @type {?} */
SignaturePadControlComponent.prototype.formControlName;
/** @type {?} */
SignaturePadControlComponent.prototype.control;
/** @type {?} */
SignaturePadControlComponent.prototype.onTouch;
/** @type {?} */
SignaturePadControlComponent.prototype.onModelChange;
/** @type {?} */
SignaturePadControlComponent.prototype.parentFormContainer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
